import type { Component } from 'vue';
import { markRaw } from 'vue';
import type { Modal } from './types/modal';

export const defineModal = <P, V>(component: Component<P>, defaultValue: V): Modal<P, V> => ({
  component: markRaw(component),
  defaultValue,
});
